import React from "react";
import * as constants from '../../constants';
import CPSettingText from "../../../../../UI/Settings/CPSettingText";
import CPSettingToggle from "../../../../../UI/Settings/CPSettingToggle";
import { ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import FormControlLanguage from "../../../../../UI/FormControlLanguage";

const SecondScreen = ({
    eventSettings,
    eventName,
    accessPreModeration,
    onChange
}) => {
    return (
        <>
            <p style={{ fontStyle: 'italic' }}>
                {constants.PLACEHOLDERS_HINT}
            </p>
            <CPSettingText
                type="textarea"
                eventSetting={eventSettings}
                title="Заголовок"
                property={constants.WIDGET_SECOND_SCREEN_TITLE}
                toggleProperty={constants.WIDGET_SECOND_SCREEN_TITLE_HIDDEN}
                rows={3}
                defaultValue={constants.DEFAULT_CONFIRMATION_TITLE(accessPreModeration, eventName)}
                onUpdate={onChange}
            />
            <CPSettingText
                type="textarea"
                maxLength={255}
                eventSetting={eventSettings}
                title="Основной текст"
                property={constants.WIDGET_SECOND_SCREEN_TEXT}
                toggleProperty={constants.WIDGET_SECOND_SCREEN_SUBTITLE_HIDDEN}
                rows={5}
                defaultValue={constants.DEFAULT_CONFIRMATION_TEXT(accessPreModeration)}
                onUpdate={onChange}
            />
            <CPSettingToggle
                name={'secondScreenButton'}
                isChecked={eventSettings?.secondScreenButton}
                label="Показывать дополнительную кнопку"
                onChange={onChange}
            />
            {eventSettings?.secondScreenButton && <>
                <FormGroup>
                    <ControlLabel>Ссылка</ControlLabel>
                    <FormControl
                        type="text"
                        name="secondScreenButtonLink"
                        value={eventSettings?.secondScreenButtonLink || ''}
                        onChange={(e) => onChange({ secondScreenButtonLink: e.target.value })}
                    />
                </FormGroup>
                <FormGroup>
                    <ControlLabel>Текст</ControlLabel>
                    <FormControlLanguage
                        componentClass="text"
                        type={"text"}
                        values={{
                            ru: eventSettings?.secondScreenButtonTextRu || '',
                            en: eventSettings?.secondScreenButtonTextEn || '',
                        }}
                        onChange={{
                            ru: (e) => onChange({ secondScreenButtonTextRu: e.target.value }),
                            en: (e) => onChange({ secondScreenButtonTextEn: e.target.value }),
                        }}
                    />
                </FormGroup>
                <CPSettingToggle
                    name={'secondScreenButtonAccentColor'}
                    isChecked={eventSettings?.secondScreenButtonAccentColor}
                    label="Использовать акцентный цвет"
                    onChange={onChange}
                />
            </>}
            <hr />
            {
                !accessPreModeration &&
                <CPSettingToggle
                    name={constants.WIDGET_CALENDAR_BUTTON_HIDDEN}
                    isChecked={eventSettings?.[constants.WIDGET_CALENDAR_BUTTON_HIDDEN]}
                    label="Cкрыть кнопку 'Добавить в календарь'"
                    onChange={onChange}
                />
            }
        </>
    );
};

export default SecondScreen;
